// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mvI0","content":"styles_content__T2or8","tableWrap":"styles_tableWrap__2G5HR"};